module.exports = __webpack_public_path__ + "assets/img/icon_oil.14dcc312.svg";